module.exports = __webpack_public_path__ + "img/disclaimer-icon.svg";